import React, { useState, useEffect, useRef } from "react";
import anime from "animejs";

import { generatorSize } from "../../../constants";
import Background from "./Background";
import Body from "./Body";
import Ears from "./Ears";
import Eyes from "./Eyes";
import Nose from "./Nose";

const Cat = ({ schema }) => {
  const [internalSchema, setInternalSchema] = useState(schema);
  const backgroundRef = useRef(null);
  const catRef = useRef(null);

  useEffect(() => {
    const background = backgroundRef.current;
    const cat = catRef.current;

    if (background && cat && internalSchema !== schema) {
      anime
        .timeline({ easing: "easeOutExpo", duration: 700 })
        .add({
          targets: background,
          opacity: 0,
        })
        .add({
          delay: 500,
          targets: background,
          opacity: 1,
        });

      anime
        .timeline({ duration: 700 })
        .add({
          easing: "easeInExpo",
          targets: cat,
          translateY: generatorSize,
          complete: () => {
            setInternalSchema(schema);
          },
        })
        .add({
          easing: "easeOutExpo",
          targets: cat,
          translateY: 0,
        });
    }
  }, [schema, internalSchema]);

  const { paths, colors, eyes, ears, nose } = internalSchema;

  return (
    <div className="w-full h-auto">
      <svg
        className="w-full h-auto"
        width={generatorSize}
        height={generatorSize}
        viewBox={`0 0 ${generatorSize} ${generatorSize}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g ref={backgroundRef}>
          <Background
            primary={colors.background.primary}
            secondary={colors.background.secondary}
            paths={paths.background}
          />
        </g>
        <g ref={catRef}>
          <Body fill={colors.cat.primary} path={paths.cat} />
          <Ears
            left={ears.leftCoords}
            right={ears.rightCoords}
            color={ears.color}
            scale={ears.scale}
            rotation={ears.rotation}
          />
          <Eyes
            container={eyes.container}
            inner={eyes.inner}
            coordinates={eyes.coordinates}
            highlightOpacity={eyes.highlightOpacity}
          />
          <Nose
            coordinates={nose.coordinates}
            size={nose.size}
            color={nose.color}
          />
        </g>
      </svg>
    </div>
  );
};

export default Cat;
